import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BackToSchoolWrapper = styled.div`
  width: 100%;
  max-width: 900px;
  margin: auto;
  text-align: center;
`

export const PlanCardsGrid = styled.div`
  display: grid;
  gap: ${Spacing.S16};
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
`
